import React from "react";
import { Incident, Unschedule } from "../../models/Incidents";
import { toCamelCase } from "../../hooks/toCameCase.tsx";

const isNocturnoShift = (shift?: string) =>
  String(shift || "").trim().toLowerCase() === "nocturno";

const BranchLabel = ({ branchName }: { branchName: string }) => (
  <span
    className="text-secondary"
    style={{
      fontSize: "10px",
      marginTop: "2px",
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
    }}
  >
    <i className="fa-solid fa-store" style={{ fontSize: "9px", opacity: 0.8 }} />
    {branchName}
  </span>
);

const PartnerDetails = ({
  record,
  branchName,
}: {
  record: Incident;
  branchName?: string;
}) => {
  const isFromDirectBoss = (record as any)._fromDirectBoss === true;
  const person = record.schedule?.partner?.person;
  const isNocturno =
    isNocturnoShift(record.schedule?.partner?.candidate?.shift?.name) ||
    isNocturnoShift(record.schedule?.shift);

  const fullName = [
    person?.firstName,
    person?.lastName,
    person?.secondLastName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="incidents-partner-details" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <span style={{ fontSize: "13px", fontWeight: "600" }}>
        {toCamelCase(fullName || "Colaborador")}
        {isNocturno && (
          <i
            className="fa-solid fa-moon ms-1 text-dark"
            title="Este colaborador tiene turno Nocturno registrado"
          ></i>
        )}
      </span>
      {isFromDirectBoss && (
        <span
          className="incidents-badge-boss"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: "#ede9fe",
            color: "#7c3aed",
            fontSize: "10px",
            fontWeight: 600,
            padding: "2px 8px",
            borderRadius: "12px",
            marginTop: "3px",
          }}
        >
          <i className="fa-solid fa-user-tie" style={{ fontSize: "9px" }} />
          Revision como Jefe directo
        </span>
      )}
      <span className="text-secondary" style={{ fontSize: "11px", marginTop: "2px" }}>
        {record.schedule?.positionName || ""} - {record.schedule?.shift || ""}
      </span>
      {branchName ? <BranchLabel branchName={branchName} /> : null}
    </div>
  );
};

export default PartnerDetails;

export const PartnerDetailsUnschedule = ({
  record,
  showNightIcon,
  branchName,
}: {
  record: Unschedule;
  /** Sucursal con horario nocturno + turno RH «Nocturno». */
  showNightIcon?: boolean;
  branchName?: string;
}) => {
  const isNocturno =
    showNightIcon ?? isNocturnoShift(record.partner.candidate?.shift?.name);

  const person = record.partner?.person;
  const fullName = [
    person?.firstName,
    person?.lastName,
    person?.secondLastName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="incidents-partner-details" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <span style={{ fontSize: "13px", fontWeight: "600" }}>
        {toCamelCase(fullName || "Colaborador")}
        {isNocturno && (
          <i
            className="fa-solid fa-moon ms-1 text-dark"
            title="Este colaborador tiene turno Nocturno registrado"
          ></i>
        )}
      </span>
      <span className="text-secondary" style={{ fontSize: "11px", marginTop: "2px" }}>
        {record.partner?.candidate?.vacancy?.position?.name || ""}
      </span>
      {branchName ? <BranchLabel branchName={branchName} /> : null}
    </div>
  );
};
